module.exports = __webpack_public_path__ + "img/logo.0a634890.png";